import React from "react";
import { NavLink as RouteLink } from "react-router-dom";

const  NavLink = (props: any) => {
    const { forwardedRef, ...otherProps } = props
    return <RouteLink {...otherProps} ref={forwardedRef} activeClassName="Mui-selected" />
}

export default React.memo(NavLink);